import * as React from 'react'

function SvgBnp(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 60 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#BNP_svg__clip0)">
        <path d="M0 24.094h13.315V11H0v13.094z" fill="url(#BNP_svg__paint0_linear)" />
        <path
          d="M1.042 11.235c-.258 0-.427.218-.467.524-.04.305-.333 1.748-.333 5.459 0 3.713.333 6.143.333 6.143.03.293.209.523.467.523h11.525c.257 0 .462-.204.466-.523.005-.32-.128-2.846-.128-5.625 0-2.78.128-5.977.128-5.977.006-.284-.209-.524-.466-.524H1.042z"
          fill="url(#BNP_svg__paint1_linear)"
        />
        <path
          d="M7.511 12.57c.364.153 1.825.943 2.004 1.195-.736.097-2.177.473-2.954.85l-.045.092c.856-.189 2.053-.287 2.878-.332-.308.452-.512.668-.98 1.18l-.044.098c.893-.536 1.145-.575 1.968-1.057.311.46.386 1.52.398 2.36.268-.533.593-2.54.458-2.903.546-.375.62-.677.62-.677-.5.043-.777.052-1.047.137-.64-.393-2.107-.91-3.214-1.035l-.042.092z"
          fill="url(#BNP_svg__paint2_linear)"
        />
        <path
          d="M2.059 18.81c-.072.669-.102 1.147-.006 1.682-.27.075-.508.085-.726.178l-.042.092c.347.214.63.378 1.023.562.21.45.427.755.779 1.103l.043-.093c-.064-.257-.146-.469-.115-.749.437.127.811.195 1.309.21l.042-.093c-.438-.17-.875-.304-1.228-.638.11-.309.238-.552.446-.858l.044-.094c-.376.056-.717.194-1.042.257-.256-.45-.355-1.066-.484-1.653l-.043.094z"
          fill="url(#BNP_svg__paint3_linear)"
        />
        <path
          d="M4.287 15.758s-.28-.027-.746-.013c-.393.018-.98.053-1.265.137l-.042.091c.454.02 1.075.141 1.313.38.237.239-.689.62-1.37 1.98-.683 1.359 1.236-1.16 1.772-1.448.536-.288.28.934.475 1.402l.043-.093c.054-.301.188-1.116.416-1.615.228-.499.081-.05.477-.088.396-.035.956-.056 2.02.13l.044-.09c-.243-.144-1.212-.56-2.237-.697h.034c.14-.414.316-.727.316-.727-.217.031-.836.32-1.25.65z"
          fill="url(#BNP_svg__paint4_linear)"
        />
        <path
          d="M6.879 21.49c-.016-.18-.028-.36-.036-.54-.2.273-.412.536-.636.788-.251.07-.538.067-.8.064a7.25 7.25 0 00-.294 0l-.043.094c.244.125.483.202.737.254-.206.188-.482.332-.677.463l-.042.091c.416-.098.963-.275 1.371-.516.213.01.41-.004.556-.033.146-.029.044-.095.044-.093-.027-.094-.11-.151-.135-.283.383-.296.66-.567.98-.888l.044-.094c-.316.218-.7.518-1.07.693z"
          fill="url(#BNP_svg__paint5_linear)"
        />
        <path
          d="M10.38 14.502c-.822.483-1.073.524-1.967 1.059.52-.565.701-.805 1.023-1.278-.823.044-2.02.143-2.875.332.744-.397 2.219-.839 2.997-.944-.18-.25-1.641-1.04-2.005-1.193 1.157.09 2.571.522 3.257.941.27-.084.55-.088 1.052-.133-.128.22-.134.347-.626.673.136.365-.19 2.372-.459 2.903-.01-.84-.083-1.9-.397-2.36zm-6.017 7.2a3.265 3.265 0 01-1.186-.73c.112-.31.24-.55.448-.86-.333.047-.666.101-.997.162-.27-.47-.392-.926-.529-1.558-.073.67-.101 1.15-.006 1.683a5.005 5.005 0 00-.769.27c.35.215.633.38 1.024.562.21.451.427.755.78 1.102a2.048 2.048 0 01-.071-.841c.436.127.81.194 1.306.21zm1.23-6.675a2.722 2.722 0 00-.364.712c1.217.165 2.193.79 2.193.79-1.064-.188-1.625-.165-2.022-.13-.394.038-.476.084-.476.084-.286.63-.459 1.71-.459 1.71-.193-.467-.473-1.402-.473-1.402-.537.287-1.772 1.449-1.772 1.449.679-1.36 1.368-1.98 1.368-1.98-.237-.24-.859-.36-1.314-.38.236-.096.842-.209 1.307-.23.466-.013.748.013.748.013.416-.328 1.046-.604 1.264-.636zm1.29 5.83c-.199.274-.412.536-.637.788a3.92 3.92 0 01-1.136.157c.233.12.482.206.738.256a5.145 5.145 0 01-.72.554c.416-.098.963-.275 1.37-.516.214.008.412-.005.558-.034a3.214 3.214 0 01-.092-.376 9.38 9.38 0 00.981-.89 6.62 6.62 0 01-1.026.6 10.39 10.39 0 01-.035-.538z"
          fill="#fff"
        />
        <path
          d="M18.173 16.019c.815.007 1.114.173 1.114.616a.47.47 0 01-.11.314c-.156.188-.46.285-.848.26h-.02l-.228.594h.228c.45-.013.841.129 1.042.374.093.112.14.247.14.384 0 .464-.41.703-1.215.703-.136 0-.357 0-.494-.004-.019-.57-.03-1.14-.033-1.71 0-.292.019-.943.033-1.5.093-.019.248-.03.391-.03v-.001zm-1.51-.426c.026.44.051 1.552.051 1.957 0 .374 0 1.625-.065 2.165l-.005.042H18.6c.962 0 1.977-.299 1.977-1.152 0-.534-.386-.929-1.11-1.145.537-.144.894-.51.894-.93 0-.697-.8-.959-1.552-.977h-2.156l.012.04zm8.425-.04h-.951l.038 1.06c.019.524.037 1.063.073 1.586-.06-.164-.118-.248-.408-.669 0-.015-.989-1.535-1.332-1.967l-.01-.01h-1.104v.04c.035.44.05 1.552.05 1.957 0 .374 0 1.625-.053 2.165l-.01.042h.984v-.042c-.056-1.026-.056-2.062-.056-3.066.034.121.077.226.232.456.013.027 1.707 2.493 1.79 2.634l.008.018h.788v-.042c-.061-.54-.066-1.79-.066-2.165 0-.405.027-1.518.053-1.957l.012-.04h-.038zm2.58.507c.548-.01.93.101 1.113.331.083.1.13.23.13.38 0 .608-.685.74-1.257.74l-.233-.013-.095-.01c-.004-.14-.004-.326-.004-.534 0-.264 0-.578.012-.87.11-.015.222-.023.334-.024zm-1.442-.467c.038.44.053 1.552.053 1.957 0 .374 0 1.625-.058 2.165v.042h1.17l-.005-.042c-.04-.389-.06-1.129-.064-1.694l.22.01.166.004c1.54 0 2.288-.407 2.288-1.265 0-.975-1.05-1.199-1.926-1.217h-1.845v.04zm7.444.467c.55-.01.932.101 1.116.331a.57.57 0 01.127.38c0 .608-.684.74-1.249.74l-.231-.013-.097-.01c-.007-.14-.007-.327-.007-.534 0-.267 0-.578.011-.87.073-.01.2-.024.33-.024zm-1.44-.467c.037.44.058 1.552.058 1.957 0 .374-.004 1.625-.064 2.165v.042h1.17l-.006-.042a21.995 21.995 0 01-.059-1.694l.21.01.17.004c1.54 0 2.294-.407 2.294-1.265 0-.975-1.056-1.199-1.935-1.217H32.23v.04zm5.623 1.198c.093.2.335.76.607 1.426-.042.002-.095.002-.095.002l-.512.007-.618-.009c.22-.533.44-1.015.618-1.426zm-.284-1.238h-.016l-.008.021c-.218.598-1.622 3.662-1.844 4.13l-.018.053h.996l.009-.023c.087-.288.206-.613.334-.96l.831-.012.689.005s.11.007.144.007c.177.452.313.792.372.965l.012.018h1.155l-1.866-4.204h-.79zm3.125.04c.034.44.05 1.552.05 1.957 0 .374 0 1.625-.063 2.165v.042h1.177l-.005-.042c-.062-.544-.067-1.79-.067-2.165 0-.292.01-.943.038-1.47.09-.006.226-.02.318-.02.545-.01.93.103 1.11.331.086.1.125.233.125.38 0 .485-.453.731-.876.753a1.266 1.266 0 01-.246-.012l-.082-.014.045.077a26.49 26.49 0 011.301 2.164l.007.018h1.258l-.031-.056c-.052-.071-.87-1.277-1.219-1.792l-.03-.031c.645-.194.956-.555.956-1.108 0-.968-1.05-1.198-1.937-1.217h-1.832l.003.04zm5.755-.04h-1.121l.006.04c.029.44.051 1.552.051 1.957 0 .372-.005 1.621-.058 2.165l-.004.042h1.162l-.006-.042c-.045-.544-.058-1.793-.058-2.165 0-.405.028-1.518.058-1.957v-.04h-.03zm2.605.466c.82.007 1.12.173 1.12.616a.459.459 0 01-.113.314c-.148.188-.464.285-.85.26h-.018l-.226.594h.226c.451-.013.839.129 1.04.374a.575.575 0 01.144.384c0 .464-.41.703-1.22.703-.13 0-.35 0-.487-.004-.033-.62-.033-1.457-.033-1.71 0-.292.01-.943.033-1.5.089-.019.242-.03.384-.03v-.001zm-1.51-.426c.034.44.055 1.552.055 1.957 0 .374 0 1.625-.06 2.165l-.009.042h1.958c.957 0 1.977-.299 1.977-1.152 0-.534-.388-.929-1.117-1.145.537-.144.899-.51.899-.93 0-.697-.802-.959-1.547-.977h-2.16l.005.04zm6.316 1.196c.094.196.334.755.606 1.424-.041 0-.092.004-.092.004l-.514.007s-.536-.011-.616-.011c.196-.479.401-.953.616-1.424zm.484-1.236h-.788l-.004.019c-.235.636-1.718 3.861-1.843 4.129l-.022.056h1.002l.006-.025c.084-.288.2-.611.33-.965l.829-.013.69.011.146.002c.181.452.315.795.374.965l.01.025h1.16l-1.865-4.204h-.025zm2.218 1.087c0 .739.74 1.036 1.394 1.308.51.203 1.044.417 1.044.77 0 .106-.021.195-.08.258-.123.145-.372.206-.766.184-.39-.016-.83-.14-1.326-.367l-.194-.094v.916l.133.034.077.013c.244.06.717.172 1.186.172 1.235 0 1.971-.492 1.971-1.307 0-.764-.76-1.061-1.432-1.33-.495-.2-1.008-.399-1.008-.727 0-.094 0-.37.64-.37.47 0 .929.192 1.19.291l.236.1-.001-.158v-.762l-.236-.042a5.357 5.357 0 00-1.052-.129c-1.065 0-1.776.503-1.776 1.24"
          fill="#000"
        />
      </g>
      <defs>
        <linearGradient
          id="BNP_svg__paint0_linear"
          x1={6.657}
          y1={10.673}
          x2={6.657}
          y2={24.729}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#007348" />
          <stop offset={0.6} stopColor="#8DC9AB" />
          <stop offset={1} stopColor="#00925B" />
        </linearGradient>
        <linearGradient
          id="BNP_svg__paint1_linear"
          x1={6.638}
          y1={7.693}
          x2={6.638}
          y2={23.488}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00925B" />
          <stop offset={0.3} stopColor="#8DC9AB" />
          <stop offset={0.55} stopColor="#00925B" />
          <stop offset={0.835} stopColor="#007348" />
          <stop offset={1} stopColor="#009C6D" />
        </linearGradient>
        <linearGradient
          id="BNP_svg__paint2_linear"
          x1={9.165}
          y1={22.615}
          x2={9.165}
          y2={12.394}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A678" />
          <stop offset={1} stopColor="#00925B" />
        </linearGradient>
        <linearGradient
          id="BNP_svg__paint3_linear"
          x1={2.826}
          y1={22.616}
          x2={2.826}
          y2={12.392}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A678" />
          <stop offset={1} stopColor="#00925B" />
        </linearGradient>
        <linearGradient
          id="BNP_svg__paint4_linear"
          x1={4.8}
          y1={22.614}
          x2={4.8}
          y2={12.397}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A678" />
          <stop offset={1} stopColor="#00925B" />
        </linearGradient>
        <linearGradient
          id="BNP_svg__paint5_linear"
          x1={6.509}
          y1={22.615}
          x2={6.509}
          y2={12.394}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A678" />
          <stop offset={1} stopColor="#00925B" />
        </linearGradient>
        <clipPath id="BNP_svg__clip0">
          <path fill="#fff" d="M0 0h60v35H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default SvgBnp
